export const MAX_ENTRY_FILES_REPLACE_COUNTApi = 20;
export const MAX_RUBRIC_SECTION_TITLE_LENGTHApi = 150;
export const MAX_RUBRIC_ITEM_TITLE_LENGTHApi = 150;
export const MAX_NUMBER_OF_RUBRIC_SECTIONSApi = 20;
export const MAX_NUMBER_OF_RUBRIC_SECTION_ITEMSApi = 20;
export var ContestExceptionCodesApi;
(function (ContestExceptionCodesApi) {
    ContestExceptionCodesApi["MISSING_FILTER"] = "missing_filter";
    ContestExceptionCodesApi["INVALID_FILTER"] = "invalid_filter";
    ContestExceptionCodesApi["INVALID_SORT_FIELD"] = "invalid_sort_field";
    ContestExceptionCodesApi["UNAUTHENTICATED"] = "unauthenticated";
    ContestExceptionCodesApi["DAO_EXCEPTION"] = "dao_exception";
    ContestExceptionCodesApi["DB_EXCEPTION"] = "db_exception";
})(ContestExceptionCodesApi || (ContestExceptionCodesApi = {}));
export var ContestStatusApi;
(function (ContestStatusApi) {
    ContestStatusApi["INACTIVE"] = "inactive";
    ContestStatusApi["ACTIVE"] = "active";
    ContestStatusApi["PENDING"] = "pending";
    ContestStatusApi["CLOSED"] = "closed";
    ContestStatusApi["ACTIVE_NOT_EXPIRED"] = "active_not_expired";
})(ContestStatusApi || (ContestStatusApi = {}));
export var ContestTypeApi;
(function (ContestTypeApi) {
    ContestTypeApi["REGULAR"] = "regular";
    ContestTypeApi["PREPAID"] = "prepaid";
    ContestTypeApi["GUARANTEED"] = "guaranteed";
    ContestTypeApi["FREEMIUM"] = "freemium";
})(ContestTypeApi || (ContestTypeApi = {}));
export var EntryStatusApi;
(function (EntryStatusApi) {
    EntryStatusApi["PENDING"] = "pending";
    EntryStatusApi["WITHDRAWN"] = "withdrawn";
    EntryStatusApi["WITHDRAWN_ELIMINATED"] = "withdrawn_eliminated";
    EntryStatusApi["ELIMINATED"] = "eliminated";
    EntryStatusApi["ACTIVE"] = "active";
    EntryStatusApi["WON"] = "won";
    EntryStatusApi["WON_CLOSED"] = "won_closed";
    EntryStatusApi["WON_RUNNER_UP"] = "won_runner_up";
    EntryStatusApi["WON_BRONZE"] = "won_bronze";
    EntryStatusApi["WON_SILVER"] = "won_silver";
    EntryStatusApi["CHOSEN"] = "chosen";
    EntryStatusApi["WON_GOLD"] = "won_gold";
    EntryStatusApi["DRAFT"] = "draft";
    EntryStatusApi["BOUGHT"] = "bought";
})(EntryStatusApi || (EntryStatusApi = {}));
export var ContestUpgradeApi;
(function (ContestUpgradeApi) {
    ContestUpgradeApi["FEATURED"] = "featured";
    ContestUpgradeApi["SEALED"] = "sealed";
    ContestUpgradeApi["HIGHLIGHT"] = "highlight";
    ContestUpgradeApi["NONPUBLIC"] = "nonpublic";
    ContestUpgradeApi["TOP_CONTEST"] = "top_contest";
    ContestUpgradeApi["URGENT"] = "urgent";
    ContestUpgradeApi["NDA"] = "nda";
    ContestUpgradeApi["GUARANTEED"] = "guaranteed";
    ContestUpgradeApi["CUSTOM_JUDGING"] = "custom_judging";
    ContestUpgradeApi["PROJECT_MANAGEMENT"] = "project_management";
})(ContestUpgradeApi || (ContestUpgradeApi = {}));
export var ContestBudgetClassificationApi;
(function (ContestBudgetClassificationApi) {
    ContestBudgetClassificationApi["OK"] = "ok";
    ContestBudgetClassificationApi["GOOD"] = "good";
    ContestBudgetClassificationApi["GREAT"] = "great";
    ContestBudgetClassificationApi["EXCELLENT"] = "excellent";
    ContestBudgetClassificationApi["BEST"] = "best";
    ContestBudgetClassificationApi["AMAZING"] = "amazing";
})(ContestBudgetClassificationApi || (ContestBudgetClassificationApi = {}));
export var EntryUpgradeApi;
(function (EntryUpgradeApi) {
    EntryUpgradeApi["SEALED"] = "sealed";
    EntryUpgradeApi["HIGHLIGHT"] = "highlight";
})(EntryUpgradeApi || (EntryUpgradeApi = {}));
export var MessageBoardApi;
(function (MessageBoardApi) {
    MessageBoardApi["CVP"] = "cvp";
    MessageBoardApi["ENTRY"] = "entry";
    MessageBoardApi["ENTRIES_BY_FREELANCER"] = "entries_by_freelancer";
    MessageBoardApi["HANDOVER"] = "handover";
})(MessageBoardApi || (MessageBoardApi = {}));
export var MessageContextApi;
(function (MessageContextApi) {
    MessageContextApi["GENERAL"] = "general";
    MessageContextApi["HANDOVER"] = "handover";
})(MessageContextApi || (MessageContextApi = {}));
export var HandoverUserRoleApi;
(function (HandoverUserRoleApi) {
    HandoverUserRoleApi["BUYER"] = "buyer";
    HandoverUserRoleApi["SELLER"] = "seller";
})(HandoverUserRoleApi || (HandoverUserRoleApi = {}));
export var ContestCollaborationPermissionApi;
(function (ContestCollaborationPermissionApi) {
    ContestCollaborationPermissionApi["ENTRY_RATE"] = "entry_rate";
    ContestCollaborationPermissionApi["ENTRY_REJECT"] = "entry_reject";
    ContestCollaborationPermissionApi["ENTRY_AWARD"] = "entry_award";
    ContestCollaborationPermissionApi["UNKNOWN"] = "unknown";
})(ContestCollaborationPermissionApi || (ContestCollaborationPermissionApi = {}));
export var ContestExtendUpgradeDurationApi;
(function (ContestExtendUpgradeDurationApi) {
    ContestExtendUpgradeDurationApi["THREE_DAYS"] = "three_days";
    ContestExtendUpgradeDurationApi["FIVE_DAYS"] = "five_days";
    ContestExtendUpgradeDurationApi["SEVEN_DAYS"] = "seven_days";
    ContestExtendUpgradeDurationApi["FOURTEEN_DAYS"] = "fourteen_days";
    ContestExtendUpgradeDurationApi["TWENTY_ONE_DAYS"] = "twenty_one_days";
})(ContestExtendUpgradeDurationApi || (ContestExtendUpgradeDurationApi = {}));
export var EntryFileFormatApi;
(function (EntryFileFormatApi) {
    EntryFileFormatApi["JPG"] = "jpg";
    EntryFileFormatApi["JPEG"] = "jpeg";
    EntryFileFormatApi["PNG"] = "png";
    EntryFileFormatApi["GIF"] = "gif";
    EntryFileFormatApi["PDF"] = "pdf";
    EntryFileFormatApi["MOV"] = "mov";
    EntryFileFormatApi["MPG"] = "mpg";
    EntryFileFormatApi["MPEG"] = "mpeg";
    EntryFileFormatApi["AVI"] = "avi";
    EntryFileFormatApi["FLV"] = "flv";
    EntryFileFormatApi["MP4"] = "mp4";
})(EntryFileFormatApi || (EntryFileFormatApi = {}));
export var CommentsCountContextTypeApi;
(function (CommentsCountContextTypeApi) {
    CommentsCountContextTypeApi["CONTEST"] = "contest";
    CommentsCountContextTypeApi["ENTRY"] = "entry";
    CommentsCountContextTypeApi["ANNOTATION"] = "annotation";
    CommentsCountContextTypeApi["COMMENT"] = "comment";
})(CommentsCountContextTypeApi || (CommentsCountContextTypeApi = {}));
export var ContestRubricSubmissionStatusApi;
(function (ContestRubricSubmissionStatusApi) {
    ContestRubricSubmissionStatusApi["DRAFT"] = "draft";
    ContestRubricSubmissionStatusApi["ACTIVE"] = "active";
    ContestRubricSubmissionStatusApi["REDACTED"] = "redacted";
})(ContestRubricSubmissionStatusApi || (ContestRubricSubmissionStatusApi = {}));
export const ENTRY_IMAGE_FORMATSApi = [
    EntryFileFormatApi.JPEG,
    EntryFileFormatApi.JPG,
    EntryFileFormatApi.PNG,
    EntryFileFormatApi.GIF,
];
export const ENTRY_VIDEO_FORMATSApi = [
    EntryFileFormatApi.MOV,
    EntryFileFormatApi.MPG,
    EntryFileFormatApi.MPEG,
    EntryFileFormatApi.AVI,
    EntryFileFormatApi.FLV,
    EntryFileFormatApi.MP4,
];
export const CONTEST_ATTACHMENT_IMAGE_FORMATSApi = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'bmp',
];
export const CONTEST_ATTACHMENT_VIDEO_FORMATSApi = [
    'mp4',
    'webm',
    'ogg',
];
export var ContestCommentContextTypeApi;
(function (ContestCommentContextTypeApi) {
    ContestCommentContextTypeApi["CONTEST"] = "contest";
    ContestCommentContextTypeApi["ENTRY"] = "entry";
    ContestCommentContextTypeApi["ANNOTATION"] = "annotation";
})(ContestCommentContextTypeApi || (ContestCommentContextTypeApi = {}));
export var EntriesSortApi;
(function (EntriesSortApi) {
    EntriesSortApi["NUMBER"] = "number";
    EntriesSortApi["RATING"] = "rating";
    EntriesSortApi["NUM_LIKES"] = "num_likes";
    EntriesSortApi["TIME_ENTERED"] = "time_entered";
    EntriesSortApi["FREELANCER_RATING"] = "freelancer_rating";
})(EntriesSortApi || (EntriesSortApi = {}));
